import { render, staticRenderFns } from "./CorporatePinRulesAccordion.vue?vue&type=template&id=256a9aba&scoped=true&"
import script from "./CorporatePinRulesAccordion.vue?vue&type=script&lang=js&"
export * from "./CorporatePinRulesAccordion.vue?vue&type=script&lang=js&"
import style0 from "./CorporatePinRulesAccordion.vue?vue&type=style&index=0&id=256a9aba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256a9aba",
  null
  
)

export default component.exports